module.exports = __webpack_public_path__ + "img/main-3.e196e33c.jpg";